import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MapContainer from '../map/container';
import BaseLayerContainer from '../baseLayers/container';
import Filters from '../filters/container';
import Legend from '../legend/container';
import User from '../user/container';
import MessageBar from '../messageBar/container';
import Loading from '../loading/container';
import IndustriesContainer from '../mapData/container';
import PopupContainer from '../popup/container';
import PointSizeSliderContainer from '../pointSizeSlider/container';
import ContextMenu from '../contextmenu/container';
import MapMistakesContainer from '../mapMistakes/container';
import PersonSearchContainer from '../personSearch/container';
import ToggleMapMistakes from '../mapMistakes/containerToggle';
import TogglePersonSearch from '../personSearch/containerToggle';
import MenuSharpIcon from '@material-ui/icons/MenuSharp';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    mainMenuButton: {
        backgroundColor: '#425a5e',
        borderRadius: 0,
        color: '#fff',
        height: '45px',
        margin: '0',
        minWidth: 'unset',
        padding: '0',
        position: 'absolute',
        textTransform: 'none',
        top: 10,
        width: '45px',
        zIndex: 1,
    },
    mainMenuContainer: {
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'row',
        pointerEvents: 'none',
        position: 'absolute',
        top: 10,
        zIndex: '3',
    },
    mainMenu: {
        backgroundColor: '#fff',
        boxShadow: '0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)',
        margin: '0 15px 15px 0',
        pointerEvents: 'initial',
        width: '255px',
        zIndex: 2,
    },
    mainMenuTitle: {
        display: 'flex',
        fontSize: '1.2em',
    },
    mainMenuLogo: {
        height: 'auto',
        width: '255px',
    },
    windowContainer: {
        alignItems: 'flex-start',
        display: 'flex',
        left: '280px',
        position: 'absolute',
        top: '10px',

        '@media (max-width: 700px)': {
            left: '65px',
            width: 'calc(100% - 130px)',
        },
    },
    rightButtons: {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        position: 'absolute',
        right: 12,
        top: 10,
    },
    bottomLogoContainer: {
        alignItems: 'flex-end',
        bottom: 6,
        display: 'flex',
        position: 'absolute',
    },
    bottomLogo: {
        height: 'auto',
        margin: '4px 8px 0 0',
        width: '60px',
    }
});

export const MAP_VIEW = 'MAP_VIEW';

class App extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        menuEnabled: false,
        showButton: false
      };

      this.resizeFunction = this.resizeFunction.bind(this);
    }

    componentDidMount() {
      this.resizeFunction();
      window.addEventListener('resize', this.resizeFunction);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.resizeFunction);
    }

    resizeFunction() {
      this.setState({ showButton: window.innerWidth <= 700 });
    }

    render() {
        const { classes, view, padding } = this.props;

        switch(view) {
            case MAP_VIEW:
                return (
                    <div>
                        <MapContainer />

                        <Button
                            onClick={e => {
                                this.setState({ menuEnabled: !this.state.menuEnabled })
                            }}
                            size='medium'
                            variant='contained'
                            className={classes.mainMenuButton}
                            style={{ left: (this.state.showButton ? 10: '-45px')}}
                        >
                            <MenuSharpIcon />
                        </Button>

                        <div className={classes.mainMenuContainer}
                            style={{
                                left: (this.state.showButton ? this.state.menuEnabled ? '55px': '-260px': 10),
                                flexWrap: (this.state.showButton ? 'nowrap': 'wrap')
                            }}>

                            <div className={classes.mainMenu}>
                                <div className={classes.mainMenuTitle}>
									<img src="/logo_dep.jpg" alt="logo" className={classes.mainMenuLogo} />
                                </div>

                                <IndustriesContainer />
                            </div>
                        </div>

                        <div className={classes.windowContainer}>
                            <MapMistakesContainer />
                            <PersonSearchContainer />
                        </div>

                        <div className={classes.rightButtons}>
                            <BaseLayerContainer />
                            <ToggleMapMistakes />
                            <TogglePersonSearch />
                        </div>

                        <Filters />
                        <Legend />
                        <User />
                        <MessageBar />
                        <Loading />
                        <ContextMenu />
                        <PopupContainer />

                        <div className={classes.bottomLogoContainer} style={{ left: (padding[3] + 10) }}>
                            <img src='/js_logo.jpg' alt='Jāņa Sēta' className={classes.bottomLogo} />
                            <PointSizeSliderContainer />
                        </div>
                    </div>
                );

            default:
                break;
        }
    }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/App.js